export const minutes = {
    FIFTEEN: 15
}